<div class="container">
    <div class="hero-content">
        <h1 class="hero-title">Kräuter verstehen</h1>
        <p class="hero-subtitle">
          Entdecke Herkunft, Wirkung und vielseitige Einsatzmöglichkeiten -
          von klassischem Oregano bis zu traditionellem Salbei oder erfrischender Minze.<br><br>
          Erfahre alles über Anbau, Inhaltsstoffe und die richtige Anwendung in der Hausapotheke.
        </p>
        <div class="hero-buttons">
          <!-- Gut: routerLink für Navigation -->
          <a [routerLink]="blogPath" class="btn-primary">Kräutertipps entdecken</a>
        </div>
    </div>

    <!-- Kraut des Tages -->
    <!-- Überlegung: <aside> oder <section> statt <div>, wenn es als eigenständiger Block betrachtet wird.
         Da es aber integraler Bestandteil des Hero-Bereichs ist, ist <div> oft auch in Ordnung. -->
    <div class="herb-otd-content">
      <div class="hotd-header">
        <div class="hotd-info">
          <div class="hotd-title">
            <!-- H3 ist hier passend, da die H1 bereits im linken Teil ist -->
            <h3>Kraut des Tages</h3>
            <span class="hotd-date">{{ currentDate | date:'dd. MMMM yyyy' }}</span>
          </div>

          <div class="herb-season-info">
            <div class="herb-feature">
              <h4>Saison</h4>
              <div class="season-indicator" aria-label="Saisonverlauf des Krauts über die Monate"> <!-- ARIA: Kontext für Screenreader -->
                <div class="month-row">
                  <div class="month-indicator" *ngFor="let month of months; let i = index"
                        [ngClass]="{'active': isHarvestable(herbOfTheDay, i), 'peak': isPeakSeason(herbOfTheDay, i), 'current': isCurrentMonth(i)}"
                        role="img" [attr.aria-label]="month + (isHarvestable(herbOfTheDay, i) ? (isPeakSeason(herbOfTheDay, i) ? ', Hauptsaison' : ', Erntezeit') : ', nicht in Saison') + (isCurrentMonth(i) ? ', aktueller Monat' : '')">
                        <!-- ARIA: Rolle und detailliertere Beschreibung für jeden Monat -->
                    <span>{{ month.substring(0, 1) }}</span>
                  </div>
                </div>
              </div>
              <span class="season-badge" [ngClass]="{'peak-season': isInPeakSeason(herbOfTheDay)}">
                {{ isInPeakSeason(herbOfTheDay) ? '🌿 Hauptsaison' : (isHarvestable(herbOfTheDay, currentMonthIndex) ? '✓ Erntezeit' : '⏱️ Nicht saisonal') }}
              </span>
            </div>

            <div class="herb-property">
              <h4>Eigenschaften</h4>
              <!-- Wenn herbOfTheDay.properties eine Liste ist, wäre eine <ul> semantisch besser.
                   Wenn es ein Fließtext ist, ist <p> in Ordnung.
                   Angenommen, es ist Fließtext, basierend auf der CSS-Klasse .herb-properties-list weiter unten.
                   Wenn .properties eine kommaseparierte Liste ist, die als einzelne Punkte dargestellt werden soll,
                   dann wäre es besser, dies im Component-Code zu splitten und als <ul> zu rendern.
                   Beispiel für eine Liste:
 
              -->
              <ul class="herb-properties-list">
                  <li *ngFor="let prop of herbOfTheDay.properties">
                      {{prop}}
                  </li>
              </ul>
              <!-- <p>{{ herbOfTheDay.properties }}</p> -->
            </div>

            <div class="herb-uses">
              <h4>Verwendung</h4>
              <p>{{ getShortUsesText(herbOfTheDay) }}</p>
            </div>
          </div>
        </div>

      <div class="hotd-image">
        <div class="herb-name">
          <h2>{{ herbOfTheDay.name }}</h2> 
          <p class="latin-name">{{ herbOfTheDay.latinName }}</p>
        </div>
        <img 
          fill
          [ngSrc]="heroImageSrc"
          [alt]="herbOfTheDay.name"
          priority
        >
      </div>
        
      </div>
      <!-- <button (click)="advanceToNextDay()">Nächster Tag</button> -->

      <div class="hotd-footer">
        <app-loading-spinner *ngIf="loading" position="relative"></app-loading-spinner>
        <div *ngIf="!loading && recommendedArticles.length > 0" class="recommended-blog-section">
          <h3>Hilfreiche Artikel zu {{ herbOfTheDay.name }}:</h3>
          <ul class="recommended-links-list">
            <li *ngFor="let article of recommendedArticles">
                <a [routerLink]="blogPath + '/' + article.slug">{{ article.title }}</a>
            </li>
          </ul>
        </div>
        <a class="btn-secondary" [routerLink]="['/', infoCategorySlug, herbOfTheDay.id]">Mehr zu {{ herbOfTheDay.name }}</a>
      </div>
    </div>
</div>


